import React from 'react';
import { useEmailStep } from './useEmailStep';
import { AuthEmailStepView } from './AuthEmailStepView';

type AuthEmailStepProps = {
    loading?: boolean;
    onEmailSubmit: (email: string) => void;
    error?: string | null;
    dismissError?: () => void;
    defaultEmail?: string;
};

export const AuthEmailStep: React.FC<AuthEmailStepProps> = ({
    loading,
    onEmailSubmit,
    error,
    dismissError,
    defaultEmail,
}) => {
    const { register, errors, onSubmit } = useEmailStep(onEmailSubmit, defaultEmail);
    return (
        <AuthEmailStepView
            register={register}
            errors={errors}
            onSubmit={onSubmit}
            loading={loading}
            error={error}
            dismissError={dismissError}
            defaultEmail={defaultEmail}
        />
    );
};
